// extracted by mini-css-extract-plugin
export default {"control-info":"lsf-control-info","control-info__tooltip":"lsf-control-info__tooltip","waiting":"lsf-waiting"};